export const CATDATA = [
  { id: "0", category: "default" },
  { id: "1", category: "feeling" },
  { id: "2", category: "action" },
];

export const STAGDATA = [
  {
    id: "0",
    category: "default",
    text: "Hello",
  },
  {
    id: "1",
    category: "default",
    text: "Hi",
  },
  {
    id: "2",
    category: "feeling",
    text: "I'm Sad",
  },
  {
    id: "3",
    category: "feeling",
    text: "I'm Happy",
  },
  {
    id: "4",
    category: "action",
    text: "I Want To Go Outside",
  },
  {
    id: "5",
    category: "action",
    text: "I Want To Go Home",
  },
  {
    id: "6",
    category: "action",
    text: "I Want To Go To School",
  },
];
